<template>
  <div>
    <navigation-bar
      titel="Rückmeldungen verwalten"
      showBackBtn
    ></navigation-bar>

    <section>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-skeleton-loader
              v-if="helpers.requestIsLoading"
              elevation="2"
              type="article"
            ></v-skeleton-loader>
            <request-responses-matrix
              v-else-if="request"
              :request="request"
              mode="manage"
            ></request-responses-matrix>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import RequestResponsesMatrix from "@/components/scheduling/RequestResponsesMatrix.vue";

export default {
  name: "scheduling-request-details-manage-responses",
  components: {
    NavigationBar,
    SupportTools,
    RequestResponsesMatrix,
  },
  data() {
    return {
      request: null,
      requestUnsubscribe: null,
      helpers: {
        requestIsLoading: true,
      },
    };
  },
  computed: {
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [{ title: "request", data: this.request }];
    },
  },
  created() {
    this.initialize();
  },
  beforeDestroy() {
    this.cleanupSubscription();
  },
  watch: {
    $route() {
      this.initialize();
    },
  },
  methods: {
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    enrichRequestData(rawRequest) {
      const requestData = {
        ...rawRequest,
        timeSlots: {
          ...(rawRequest.timeSlots || {}),
          start: {
            ...(rawRequest.timeSlots?.start || {}),
          },
          end: {
            ...(rawRequest.timeSlots?.end || {}),
          },
          data: [...(rawRequest.timeSlots?.data || [])],
        },
      };

      if (requestData.timeSlots.start.timestamp?.toDate) {
        requestData.timeSlots.start.timestampToDate =
          requestData.timeSlots.start.timestamp.toDate();
      }
      if (requestData.timeSlots.end.timestamp?.toDate) {
        requestData.timeSlots.end.timestampToDate =
          requestData.timeSlots.end.timestamp.toDate();
      }

      requestData.timeSlots.data = requestData.timeSlots.data.map(
        (timeSlot) => {
          const enriched = {
            ...timeSlot,
            start: {
              ...(timeSlot.start || {}),
            },
            end: {
              ...(timeSlot.end || {}),
            },
          };

          if (enriched.start.timestamp?.toDate) {
            enriched.start.timestampToDate = enriched.start.timestamp.toDate();
            enriched.start.timestampToReadableDate = this.timestampConverter(
              enriched.start.timestamp,
            );
          }
          if (enriched.end.timestamp?.toDate) {
            enriched.end.timestampToDate = enriched.end.timestamp.toDate();
            enriched.end.timestampToReadableDate = this.timestampConverter(
              enriched.end.timestamp,
            );
          }

          return enriched;
        },
      );

      return requestData;
    },
    initialize() {
      if (!this.$route.params.organizationId || !this.$route.params.itemId) {
        return;
      }

      this.helpers.requestIsLoading = true;
      this.cleanupSubscription();

      this.requestUnsubscribe = db
        .collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("requests")
        .doc(this.$route.params.itemId)
        .onSnapshot(
          (doc) => {
            this.request = doc.exists
              ? this.enrichRequestData(doc.data())
              : null;
            this.helpers.requestIsLoading = false;
          },
          () => {
            this.helpers.requestIsLoading = false;
          },
        );
    },
    cleanupSubscription() {
      if (this.requestUnsubscribe) {
        this.requestUnsubscribe();
        this.requestUnsubscribe = null;
      }
    },
  },
};
</script>
